// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkImg[data-v-02036abd]{width:10px!important}.selectFontSize[data-v-02036abd]{font-size:13px!important}.font16[data-v-02036abd]{font-size:14px!important}.mright-1[data-v-02036abd]{margin-right:.3rem!important}@media screen and (max-width:600px){.selectFontSize[data-v-02036abd]{font-size:11px!important}}", ""]);
// Exports
module.exports = exports;
